import {
  type UseQueryOptions,
  type UseQueryReturnType,
  useQuery,
  useQueryClient,
} from '@tanstack/vue-query'
import type { MaybeRef } from '@vueuse/core'
import { getElemental } from '~~/src/api/elementals'
import { ElementalTypeEnum } from '~~/src/types/elemental'
import type { GetReturn } from '~~/src/types/utils'

export const useGetElementalQuery = (
  args: {
    typeRoute?: MaybeRef<ElementalTypeEnum | undefined | null >
    id?: MaybeRef<string | number | null | undefined>
  },
  options?: Omit<
    UseQueryOptions<
      GetReturn<typeof getElemental>,
      Error
    >,
    'queryKey' | 'queryFn' | 'placeholderData' | 'keepPreviousData'
  >,
): UseQueryReturnType<GetReturn<typeof getElemental>, Error> => {
  const client = useQueryClient()
  return useQuery({
    queryKey: ['elemental', args.typeRoute, args.id] as const,
    queryFn: async ({ queryKey }) => {
      if (queryKey[1] === undefined || queryKey[2] === null || queryKey[2] === undefined)
        throw new Error('Missing typeRoute or id')

      const [_, typeRoute, id] = queryKey
      const data = await getElemental(id, typeRoute === ElementalTypeEnum.List)
      if (data && (id !== data.id)) {
        client.setQueriesData({
          queryKey: [_, typeRoute, data.id],
        }, _ => data, { updatedAt: new Date().getTime() })
      }
      return data
    },
    enabled: unref(args.id) !== null,
    ...options,
  })
}
